export default __webpack_public_path__ + "static/Blitz8 01F3701A-380fcf9101386c8f4fb1e142f99dabb4.jpg";